import { useLockSlots } from "../../LockSlots";
import { useCreateSingleSlotBookings } from "../hooks/useCreateSingleSlotBookings";

export const useReserveMultipleTimesNewFlow = (
  selectedTeeTimes: string[],
  memberId: string,
  navigateToSummaryMultipleTeeTimes: () => void
) => {
  const [handleLockSlot, isLocking] = useLockSlots();
  const [createSingleSlotBookings, isCreating] = useCreateSingleSlotBookings();

  const input = {
    bookings: selectedTeeTimes.map((slotId, index) => ({
      startSlotId: slotId,
      guestRounds: [],
      memberRounds:
        index === 0
          ? [
              {
                courseLayoutId: null,
                index: 0,
                nonPlayingHost: false,
                playerId: memberId,
                transportationTypeId: null,
              },
            ]
          : [],
      newGuestRounds: [],
      notesFromMember: "",
      isDraft: true,
    })),
    notifyMember: true,
  };

  const reserveMultipleTimesNewFlow = () => {
    handleLockSlot({ timeSlotIds: selectedTeeTimes }, () => {});
    createSingleSlotBookings(input, (bookingId) => {
      navigateToSummaryMultipleTeeTimes();
    });
  };

  return { reserveMultipleTimesNewFlow, isLocking, isCreating };
};
